import React from "react";
import { createRoot } from "react-dom/client";
import ContactForm from "./contact-form";

import "../view.css";

document.addEventListener("DOMContentLoaded", function () {
	const element = document.getElementById("react-app");
	if (!element) {
		return;
	}
	const root = createRoot(element);
	root.render(<ContactForm />);
	// console.log("gextContactForm");
	// const form = document.querySelector(".gext-form__form");
	// console.log(form);
	// if (!form) {
	// 	return;
	// }

	// const container = form.closest(".gext-form");
	// const messageBox = container.querySelector(".gext-form__message");
	// const submitButton = form.querySelector('button[type="submit"]');
	// const originalButtonText = submitButton.textContent;

	// form.addEventListener("submit", async function (e) {
	// 	e.preventDefault();

	// 	// Désactiver le bouton et afficher un état de chargement
	// 	submitButton.disabled = true;
	// 	submitButton.textContent = "Envoi en cours...";

	// 	// Cacher le message précédent
	// 	messageBox.hidden = true;
	// 	messageBox.className = "gext-form__message";

	// 	// Collecter les données du formulaire
	// 	const formData = new FormData(form);
	// 	formData.append("action", "gext_contact_form_submit");
	// 	formData.append("nonce", gextContactForm.nonce);

	// 	try {
	// 		const response = await fetch(gextContactForm.ajaxUrl, {
	// 			method: "POST",
	// 			body: formData,
	// 		});

	// 		const result = await response.json();

	// 		if (result.success) {
	// 			// Succès : afficher le message et masquer le formulaire
	// 			messageBox.textContent = result.data.message;
	// 			messageBox.classList.add("gext-form__message--success");
	// 			messageBox.hidden = false;
	// 			form.style.display = "none";
	// 		} else {
	// 			// Erreur : afficher le message d'erreur
	// 			messageBox.textContent =
	// 				result.data.message || "Une erreur est survenue.";
	// 			messageBox.classList.add("gext-form__message--error");
	// 			messageBox.hidden = false;

	// 			// Réactiver le bouton
	// 			submitButton.disabled = false;
	// 			submitButton.textContent = originalButtonText;
	// 		}
	// 	} catch (error) {
	// 		// Erreur réseau
	// 		messageBox.textContent =
	// 			"Une erreur de connexion est survenue. Veuillez réessayer.";
	// 		messageBox.classList.add("gext-form__message--error");
	// 		messageBox.hidden = false;

	// 		// Réactiver le bouton
	// 		submitButton.disabled = false;
	// 		submitButton.textContent = originalButtonText;
	// 	}
	// });
});
